/** @format */
import { KeyboardEvent } from 'react';

/**
 * Returns true if the key press should trigger an event
 * @param keyboardEvent a keyboard event triggered by HTML a div element
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export const shouldKeyDownTriggerEvent = ({ code }: KeyboardEvent<any>) => {
    const validKeysCodes = ['Enter', 'Space'];

    return validKeysCodes.includes(code);
};
